var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.wxPayUrl != '')?_c('vue-qr',{attrs:{"size":200,"text":_vm.wxPayUrl,"logoSrc":_vm.icon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }